// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CEh7","colBig":"styles_colBig__1N4_N","colSmall":"styles_colSmall__1hlOn"};